"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _reactRedux = require("react-redux");

var _shipping = require("../../store/shipping");

var _shipping2 = require("../../store/shipping/shipping.actions");

var _shipping3 = require("../../store/shipping/shipping.types");

var _AddressRadioOption = _interopRequireDefault(require("./AddressRadioOption"));

var _VerifiedAddress = _interopRequireDefault(require("./VerifiedAddress"));

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
var AddressSelectionForm = function AddressSelectionForm(_ref) {
  var originalAddress = _ref.originalAddress,
      setTargetAddress = _ref.setTargetAddress;
  var dispatch = (0, _reactRedux.useDispatch)();
  var isAddressVerified = (0, _reactRedux.useSelector)(_shipping.getIsAddressVerified);
  var verifiedAddress = (0, _reactRedux.useSelector)(_shipping.getVerifiedAddress);

  var _useState = (0, _react.useState)(_shipping3.AddressOption.none),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      addressOption = _useState2[0],
      setAddressOption = _useState2[1];

  var isOriginalSelected = addressOption === _shipping3.AddressOption.original;
  var isVerifiedSelected = addressOption === _shipping3.AddressOption.verified;
  var handleSelectAddressOption = (0, _react.useCallback)(function (_ref2) {
    var target = _ref2.target;
    setAddressOption(target.value);
    setTargetAddress(target.value);
  }, [setTargetAddress, setAddressOption]);
  var handleEditOriginalAddress = (0, _react.useCallback)(function () {
    dispatch((0, _shipping2.resetVerification)());
  }, [dispatch]);
  (0, _react.useEffect)(function () {
    if (isAddressVerified) {
      setAddressOption(_shipping3.AddressOption.verified);
      setTargetAddress(_shipping3.AddressOption.verified);
    } else {
      setTargetAddress(_shipping3.AddressOption.original);
      setAddressOption(_shipping3.AddressOption.original);
    }
  }, [isAddressVerified, setTargetAddress]);

  var transformAddress = function transformAddress(address) {
    return {
      formattedAddress: "".concat(address.address_line_1, " # ").concat(address.address_line_2),
      addressLines: [address.address_line_1, address.address_line_2],
      city: address.city,
      stateName: address.state,
      zipcode: address.zip,
      phone: address.phone
    };
  };

  return /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement(_material.RadioGroup, {
    value: addressOption,
    onChange: handleSelectAddressOption
  }, isAddressVerified && /*#__PURE__*/_react.default.createElement(_material.Box, {
    borderRadius: "5px",
    bgcolor: "green.fruitSaladLight",
    width: 1,
    mt: 1,
    mb: 3,
    p: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-Static"
  }, "We recommend selecting ", /*#__PURE__*/_react.default.createElement("strong", null, "verified address"), " to ensure a timely delivery.")), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "H4-Dark-Bold"
  }, "Original address")), /*#__PURE__*/_react.default.createElement(_AddressRadioOption.default, {
    label: originalAddress ? /*#__PURE__*/_react.default.createElement(_VerifiedAddress.default, {
      address: transformAddress(originalAddress)
    }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null),
    value: _shipping3.AddressOption.original,
    isActive: isOriginalSelected,
    onEdit: handleEditOriginalAddress
  }), isAddressVerified && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 3
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "H4-Dark-Bold"
  }, "Verified address")), /*#__PURE__*/_react.default.createElement(_AddressRadioOption.default, {
    label: verifiedAddress ? /*#__PURE__*/_react.default.createElement(_VerifiedAddress.default, {
      address: verifiedAddress
    }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null),
    value: _shipping3.AddressOption.verified,
    isActive: isVerifiedSelected
  })), !isAddressVerified && /*#__PURE__*/_react.default.createElement(_material.Box, {
    borderRadius: "5px",
    bgcolor: "link.light",
    width: 1,
    mt: 1,
    p: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-White"
  }, "We couldn\u2019t verify the address which may ", /*#__PURE__*/_react.default.createElement("strong", null, "delay a delivery.")), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-White"
  }, "Please edit or chose the original address to proceed."))));
};

var _default = /*#__PURE__*/(0, _react.memo)(AddressSelectionForm);

exports.default = _default;